/*    
<summary>
   This functional component provides us functionalities like redirection to other modules, logout & User Profile.
   Developer:Aashish Singh, Created Date:29-March-2023
</summary>
<returns>Returns JSX</returns>
*/
import React, { useEffect, useRef } from "react";
import "./left-navbar.css";
import { NavLink, useHistory } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import { formatMessage } from "../../translations/format-message";
import { observer } from "mobx-react";
import CentraIoTLogo from "../../assets/Images/logo-small.svg";
import Huckster_Small_icon from "../../assets/Images/Huckster_Small_icon.png";
import { useStore } from "../../contexts/store-provider";
import UserProfilePopup from "../../modules/auth/user-profile-popup";
import LogoutPopup from "../../modules/auth/components/logout-popup";
import UserProfilePopupHOC from "../../modules/auth/hoc/user-profile-popup-hoc";
import LogoutPopupHOC from "../../modules/auth/hoc/logout-popup-hoc";
import RoutesConstants from "../routes/routes-constants";
import userTypeEnum from "../../constants/enums/user-type-enum";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getIsTenantAccessFromLocalStorage } from "../../helpers/localstorage-helper";
import { findRouteAccess } from "../../helpers/route-helper";
import { ModuleType } from "../../constants/enums/module-type-enum";

interface IProps {
  changeLanguage: (lang: string) => void;
}

const LeftNavBar = (props: any) => {
  /* eslint-disable jsx-a11y/anchor-is-valid */
  let t: NodeJS.Timeout;
  const history = useHistory();
  const { preferencesStore, authStore } = useStore();
  const myRef = useRef<any>();
  const { getUserType, userType } = authStore;
  const {
    getTenantAccess,
    setTenantAccess,
    getParkingLotCameraAccess,
    resetMediaAccess,
    resetPriceSchedulerAccess,
    resetParkingLotCameraAccess,
    resetUnwantedModules,
    setParkingFilter,
    setUserLogsFilter,
    setSystemLogsFilter
  } = preferencesStore;
  const isHucksterUser =
    (getUserType === userTypeEnum[0] ||
      getUserType === userTypeEnum[1] ||
      getUserType === userTypeEnum[4]) &&
    getIsTenantAccessFromLocalStorage() == false;
  const isCompany =
    (getUserType === userTypeEnum[2] || getUserType === userTypeEnum[3]) &&
    getIsTenantAccessFromLocalStorage() == false;

  const handleChange = () => {
    const div = document.getElementById("left-sidebarNav");
    const move = document.getElementById("moveContent");
    if (div) {
      
      if (!div.className.includes("closeNav")) {
      div.classList.add("closeNav");
      if (move) move.classList.remove("ShiftLeftSide");
        
      } else {
        div.classList.remove("closeNav");
        if (move) move.classList.add("ShiftLeftSide");
      }
    }
  };

  const handleChange2 = () => {
    const div = document.getElementById("left-sidebarNav");
    const move = document.getElementById("moveContent");
    if (div !== null) {
      div.classList.add("closeNav");
      if (move) move.classList.remove("ShiftLeftSide");
    }
  };

  const closeOnOutsideClick = () => {
    var div = document.getElementById("left-sidebarNav");
    const move = document.getElementById("moveContent");
    if (div) {
      if (!div.className.includes("closeNav")) {
        
        div.classList.add("closeNav");
        if (move) move.classList.remove("ShiftLeftSide");
      }
    }
  };

  const handleClickOutside = (e: any) => {
    if (!myRef.current.contains(e.target)) {
      // closeOnOutsideClick();
    }
  };

  const resetExtraModules = () => {
    resetUnwantedModules();
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const exitTenant = () => {
    setTenantAccess({
      isAccessTenantActive: false,
      tenantId: 0,
      tenantName: "",
      orgId: "",
    });
    setParkingFilter({
      ParkingLotName: "",
      ParkingLotId: "",
      BranchName: "",
      Status: -1,
      IsFilterActive: false,
    })
    setUserLogsFilter({
      UserId: "",
      Company: "",
      Target: "",
      TargetItems: [],
      Type: "",
      TypeItems: [],
      Content: "",
      ContentItems: [],
      BranchName: "",
      IsFilterActive: false,
    })
    setSystemLogsFilter({
      UserId: "",
      BranchName: "",
      ParkingLotName: "",
      Target: "",
      TargetItems: [],
      IsFilterActive: false,
    })
    resetParkingLotCameraAccess();
    resetMediaAccess();
    resetPriceSchedulerAccess();
        closeOnOutsideClick();
        if(userType!==userTypeEnum[0]){{
          const div = document.getElementById("exit");
          const move = document.getElementById("moveContent");
          if (div) {
            
            if (!div.className.includes("closeNav")) {
              div.classList.remove("closeNav");
             if (move) move.classList.remove("ShiftLeftSide");
            } else {
              div.classList.add("closeNav");
              if (move) move.classList.add("ShiftLeftSide");
            }
          }
        }
      }
    const div = document.getElementById("exit");
    const move = document.getElementById("moveContent");
    if (div) {
      
      if (!div.className.includes("closeNav")) {
        div.classList.add("closeNav");
        if (move) move.classList.remove("ShiftLeftSide");
      } else {
        div.classList.remove("closeNav");
        if (move) move.classList.add("ShiftLeftSide");
      }
    }
    history.push(RoutesConstants.TenantManagement);
  };

  const exitTenantHandler = () => {
    resetParkingLotCameraAccess();
    resetMediaAccess();
    resetPriceSchedulerAccess();
     closeOnOutsideClick();
    history.push(RoutesConstants.TenantManagement);
  };
  return (
    <React.Fragment>
      {props.showUserProfilePopup && (
        <UserProfilePopup
          userName={props.email}
          userType={props.userType}
          modalClosed={props.UserProfileToggleHandler}
        />
      )}
      {props.showLogoutPopup && (
        <LogoutPopup modalClosed={props.logoutPopupToggleHandler} />
      )}

      <aside
        id="left-sidebarNav"
        ref={myRef}
        className={` ${
          getIsTenantAccessFromLocalStorage() == true &&
          getUserType === userTypeEnum[4]
            ? "primary-navbar"
            : ""
        } closeNav`}
      >
        <button
          id="nav-toogle"
          className="menu-toggle"
          onClick={handleChange}
          title={formatMessage("menu")}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div className="nav-inner">
          <nav>
            <div className="sidebar-header">
              <div
                className="sidebar-logo"
                title={formatMessage("application_title")}
              >
                <img
                  src={CentraIoTLogo}
                  className="openNav-logo img-fluid"
                ></img>
                <img
                  src={Huckster_Small_icon}
                  className="closeNav-logo img-fluid"
                ></img>
              </div>
            </div>
            <ul className="list-unstyled">
              {isHucksterUser && (
                <React.Fragment>
                  {findRouteAccess(ModuleType.TenantManagement) && (
                    <li title={formatMessage("tenant_title")}>
                      <NavLink to={RoutesConstants.TenantManagement}>
                        <span className="svgWidth">
                          <svg
                            fill="rgb(134, 137, 144)"
                            height="26"
                            width="26"
                            id="Layer_2"
                            data-name="Layer 2"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 10.59 16.79"
                          >
                            <g id="_レイヤー_4" data-name="レイヤー 4">
                              <path d="M9.22,5.18V0H1.36V5.18H0v11.61H10.59V5.18h-1.36Zm-4.25,11.28H2.87v-3.37h2.11v3.37Zm2.74,0h-2.11v-3.37h2.11v3.37Zm0-5.69H2.87v-.6H7.72v.6Zm0-1.99H2.87v-.6H7.72v.6Zm0-1.99H2.87v-.6H7.72v.6Zm0-1.99H2.87v-.6H7.72v.6Zm0-1.99H2.87v-.6H7.72v.6Z" />
                            </g>
                          </svg>
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="tenant_title" />}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {findRouteAccess(ModuleType.TenantManagement) && (
                    <li
                      title={formatMessage("user_title")}
                      className="dropdown"
                    >
                      <NavLink
                        to={RoutesConstants.HucksterUser}
                        data-bs-toggle="dropdown"
                        className="dropdown-toggle"
                      >
                        <span className="svgWidth">
                          <svg
                            id="Layer_2"
                            fill="rgb(134, 137, 144)"
                            height="23"
                            width="23"
                            data-name="Layer 2"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 15.56 15.56"
                          >
                            <g id="_レイヤー_4" data-name="レイヤー 4">
                              <path d="M13.18,9.26l.13-.48h2.25v-2h-2.25l-.13-.48c-.12-.45-.3-.88-.53-1.28l-.25-.44,1.59-1.59-1.41-1.41-1.59,1.59-.44-.25c-.41-.23-.84-.41-1.28-.53l-.49-.13V0h-2V2.25l-.49,.13c-.44,.12-.87,.3-1.28,.53l-.44,.25-1.59-1.59-1.41,1.41,1.59,1.59-.25,.44c-.23,.4-.41,.83-.53,1.28l-.13,.49H0v2H2.25l.13,.48c.12,.44,.3,.88,.53,1.28l.25,.44-1.59,1.59,1.41,1.41,1.59-1.59,.44,.25c.41,.23,.84,.41,1.28,.53l.49,.13v2.25h2v-2.25l.49-.13c.44-.12,.87-.3,1.28-.53l.44-.25,1.59,1.59,1.41-1.41-1.59-1.59,.25-.44c.23-.4,.41-.83,.53-1.28Zm-5.4,1.02c-1.38,0-2.51-1.13-2.51-2.51s1.13-2.51,2.51-2.51,2.51,1.13,2.51,2.51-1.13,2.51-2.51,2.51Z" />
                            </g>
                          </svg>
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="user_title" />}
                        </span>
                      </NavLink>
                      <ul className="dropdown-menu">
                        <li>
                          <React.Fragment>
                            <NavLink
                              className="dropdown-item"
                              to={RoutesConstants.HucksterUser}
                            >
                              <FormattedMessage id="huckster_user" />
                            </NavLink>
                          </React.Fragment>
                        </li>
                        <li>
                          <React.Fragment>
                            <NavLink
                              className="dropdown-item"
                              to={RoutesConstants.SystemUser}
                            >
                              <FormattedMessage id="system_user" />
                            </NavLink>
                          </React.Fragment>
                        </li>
                      </ul>
                    </li>
                  )}
                </React.Fragment>
              )}

              {isCompany && (
                <React.Fragment>
                  {findRouteAccess(ModuleType.CompanyUserManagement) && (
                    <li title={formatMessage("system_user")}>
                      <NavLink to={RoutesConstants.SystemUser}>
                        <span className="svgWidth svg-icon">
                          <svg
                            id="Layer_2"
                            data-name="Layer 2"
                            fill="rgb(134, 137, 144)"
                            height="26"
                            width="26"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 15.56 15.56"
                          >
                            <g id="_レイヤー_4" data-name="レイヤー 4">
                              <path d="M13.18,9.26l.13-.48h2.25v-2h-2.25l-.13-.48c-.12-.45-.3-.88-.53-1.28l-.25-.44,1.59-1.59-1.41-1.41-1.59,1.59-.44-.25c-.41-.23-.84-.41-1.28-.53l-.49-.13V0h-2V2.25l-.49,.13c-.44,.12-.87,.3-1.28,.53l-.44,.25-1.59-1.59-1.41,1.41,1.59,1.59-.25,.44c-.23,.4-.41,.83-.53,1.28l-.13,.49H0v2H2.25l.13,.48c.12,.44,.3,.88,.53,1.28l.25,.44-1.59,1.59,1.41,1.41,1.59-1.59,.44,.25c.41,.23,.84,.41,1.28,.53l.49,.13v2.25h2v-2.25l.49-.13c.44-.12,.87-.3,1.28-.53l.44-.25,1.59,1.59,1.41-1.41-1.59-1.59,.25-.44c.23-.4,.41-.83,.53-1.28Zm-5.4,1.02c-1.38,0-2.51-1.13-2.51-2.51s1.13-2.51,2.51-2.51,2.51,1.13,2.51,2.51-1.13,2.51-2.51,2.51Z" />
                            </g>
                          </svg>
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="system_user" />}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {findRouteAccess(ModuleType.BranchManagement) && (
                    <li title={formatMessage("branch_title")}>
                      <NavLink
                        to={RoutesConstants.BranchManagement}
                        onClick={() => {
                          resetExtraModules();
                        }}
                      >
                        <span className="svgWidth svg-icon">
                          <svg
                            id="Layer_2"
                            fill="rgb(134, 137, 144)"
                            height="25"
                            width="25"
                            data-name="Layer 2"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 11.25 14.38"
                          >
                            <g id="_レイヤー_4" data-name="レイヤー 4">
                              <g>
                                <rect
                                  x="4.57"
                                  y="10.83"
                                  width="2.11"
                                  height="3.55"
                                />
                                <path d="M0,0V14.38H3.04v-4.31c0-.42,.34-.77,.77-.77h3.64c.42,0,.77,.34,.77,.77v4.31h3.04V0H0ZM4.79,6.62H2.03v-1.88h2.75v1.88Zm0-3.37H2.03V1.38h2.75v1.88Zm4.43,3.37h-2.75v-1.88h2.75v1.88Zm0-3.37h-2.75V1.38h2.75v1.88Z" />
                              </g>
                            </g>
                          </svg>
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="branch_title" />}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {findRouteAccess(ModuleType.MediaManagement) && (
                    <li
                      title={formatMessage("media_title")}
                      onClick={() => {
                        resetExtraModules();
                      }}
                    >
                      <NavLink to={RoutesConstants.FoldersManagement}>
                        <span className="svgWidth">
                          <svg
                            id="Layer_2"
                            data-name="Layer 2"
                            fill="rgb(134, 137, 144)"
                            height="26"
                            width="26"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 15.7 15.32"
                          >
                            <g id="_レイヤー_4" data-name="レイヤー 4">
                              <g>
                                <path d="M7.65,0C4.83,0,2.53,2.3,2.53,5.12s2.3,5.12,5.12,5.12,5.12-2.3,5.12-5.12S10.47,0,7.65,0Zm.4,6.3l-2.04,1.18V2.76l2.04,1.18,2.04,1.18-2.04,1.18Z" />
                                <path d="M15.68,8.35c-.08-.37-.38-.65-.76-.7l-2.64-.36c-.14,.3-.31,.58-.5,.84l3.01,.39-5.53,3.56L1.1,11.03l3.19-2.06c-.24-.21-.45-.43-.65-.68l-3.04,1.96c-.32,.21-.48,.58-.39,.96s.38,.65,.76,.7l8.17,1.1h0s.08,0,.12,0c.17,0,.35-.05,.49-.14l5.54-3.57c.32-.21,.48-.58,.39-.96Z" />
                                <path d="M15.5,10.65c-.08-.37-.38-.65-.76-.7l-1.08-.14-1.17,.75,2.11,.27-5.53,3.56L.92,13.33l2.43-1.57-1.41-.19-1.52,.98c-.32,.21-.48,.59-.39,.96s.38,.65,.76,.7l8.17,1.1h0s.08,0,.12,0c.17,0,.35-.05,.49-.14l5.54-3.57c.32-.21,.48-.59,.39-.96Z" />
                              </g>
                            </g>
                          </svg>
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="media_title" />}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {findRouteAccess(ModuleType.ParkingManagementList) && (
                    <li
                      title={formatMessage("parking_lot_title")}
                      onClick={() => {
                        resetExtraModules();
                      }}
                    >
                      <NavLink to={RoutesConstants.ParkingLotManagement}>
                        <span className="svgWidth svg-icon">
                          <svg
                            id="Layer_2"
                            data-name="Layer 2"
                            fill="rgb(134, 137, 144)"
                            height="23"
                            width="23"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 14.32 12.79"
                          >
                            <g id="_レイヤー_4" data-name="レイヤー 4">
                              <path d="M13.36,4.09h-.45l-1.15-3.47c-.11-.37-.44-.62-.83-.62H3.39c-.38,0-.72,.25-.83,.62l-1.15,3.47h-.45c-.53,0-.96,.43-.96,.97v7.74H2.21v-2.19H12.11v2.19h2.21V5.06c0-.53-.43-.97-.97-.97ZM3.85,8.39H1.6v-1.5H3.85v1.5Zm-.57-3.81l.97-2.75h5.77l.97,2.75H3.29Zm9.43,3.81h-2.25v-1.5h2.25v1.5Z" />
                            </g>
                          </svg>
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="parking_lot_title" />}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {findRouteAccess(ModuleType.SystemLog) && (
                    <li
                      title={formatMessage("system_logs_title")}
                      onClick={() => {
                        resetExtraModules();
                      }}
                    >
                      <NavLink to={RoutesConstants.SystemLogs}>
                        <span className="svgWidth">
                          <svg
                            id="Layer_2"
                            fill="rgb(134, 137, 144)"
                            height="26"
                            width="26"
                            data-name="Layer 2"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 16.47 12.13"
                          >
                            <g id="_レイヤー_4" data-name="レイヤー 4">
                              <g>
                                <path d="M12.79,12.13H2.38c-1.31,0-2.38-1.07-2.38-2.38V2.38C0,1.07,1.07,0,2.38,0H12.79c1.31,0,2.38,1.07,2.38,2.38v1.52h-1.13v-1.52c0-.69-.56-1.25-1.25-1.25H2.38c-.69,0-1.25,.56-1.25,1.25v7.36c0,.69,.56,1.25,1.25,1.25H12.79c.69,0,1.25-.56,1.25-1.25v-1.47h1.13v1.47c0,1.31-1.07,2.38-2.38,2.38Z" />
                                <polygon points="11.08 9.44 9.41 4.73 7.32 9.21 5.82 5.78 5.01 6.98 2.99 6.98 2.99 5.85 4.41 5.85 6.03 3.43 7.35 6.46 9.55 1.74 11.32 6.73 12.83 4.05 13.83 5.63 16.47 5.63 16.47 6.76 13.21 6.76 12.89 6.25 11.08 9.44" />
                              </g>
                            </g>
                          </svg>
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="system_logs_title" />}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {findRouteAccess(ModuleType.UserLog) && (
                    <li
                      title={formatMessage("user_logs_title")}
                      onClick={() => {
                        resetExtraModules();
                      }}
                    >
                      <NavLink to={RoutesConstants.UserLogs}>
                        <span className="svgWidth">
                          <svg
                            id="Layer_2"
                            data-name="Layer 2"
                            fill="rgb(134, 137, 144)"
                            height="26"
                            width="26"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 16.95 12.33"
                          >
                            <g id="_レイヤー_4" data-name="レイヤー 4">
                              <g>
                                <path d="M1.13,8.32V2.1c0-.53,.43-.97,.97-.97H12.15c.53,0,.97,.43,.97,.97v1.59h1.13v-1.59c0-1.16-.94-2.1-2.1-2.1H2.1C.94,0,0,.94,0,2.1v6.22c0,1.16,.94,2.1,2.1,2.1h6.35v-1.13H2.1c-.53,0-.97-.43-.97-.97Z" />
                                <polygon points="16.95 11.25 13.24 7.56 15.74 6.54 8.23 3.69 11.24 11.14 12.19 8.64 15.89 12.33 16.95 11.25" />
                                <rect
                                  x="2.31"
                                  y="3.4"
                                  width="4.81"
                                  height="1.1"
                                />
                                <rect
                                  x="2.31"
                                  y="5.84"
                                  width="3.43"
                                  height="1.1"
                                />
                              </g>
                            </g>
                          </svg>
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="user_logs_title" />}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {findRouteAccess(ModuleType.SoracomAuth) && (
                    <li
                      title={formatMessage("soracom_auth")}
                      onClick={() => {
                        resetExtraModules();
                      }}
                    >
                      <NavLink to={RoutesConstants.SoracomAuth}>
                        <span className="svgWidth soraComIcon">
                          <svg
                            version="1.1"
                            id="デザイン"
                            xmlns="http://www.w3.org/2000/svg"
                            x="0px"
                            y="0px"
                            viewBox="0 0 30 30"
                            fill="rgb(134, 137, 144)"
                            height="30"
                            width="30"
                          >
                            <g>
                              <path d="M10.5,7.6H4.1C3.8,7.6,3.5,7.3,3.5,7s0.2-0.5,0.5-0.5h6.4C10.8,6.5,11,6.8,11,7S10.8,7.6,10.5,7.6z" />
                              <path d="M9.1,10h-5c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h5c0.3,0,0.5,0.2,0.5,0.5C9.6,9.7,9.4,10,9.1,10z" />
                              <path
                                d="M7.8,12.4H4.1c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h3.7c0.3,0,0.5,0.2,0.5,0.5
		C8.3,12.2,8.1,12.4,7.8,12.4z"
                              />
                              <path
                                d="M25.9,12.7l0.1-0.4h1.8v-1.6H26l-0.1-0.4c-0.1-0.4-0.2-0.7-0.4-1.1l-0.2-0.4l1.3-1.3l-1.2-1.2l-1.3,1.3
		l-0.4-0.2c-0.3-0.2-0.7-0.3-1.1-0.4l-0.4-0.1V5.1h-1.6v1.8L20.3,7c-0.4,0.1-0.7,0.2-1.1,0.4l-0.4,0.2l-1.3-1.3l-1.2,1.2l1.3,1.3
		l-0.2,0.4c-0.2,0.3-0.3,0.7-0.4,1.1L17,10.7h-1.8v1.6H17l0.1,0.4c0.1,0.4,0.2,0.7,0.4,1.1l0.2,0.4l-1.3,1.3l1.2,1.2l1.3-1.3
		l0.4,0.2c0.3,0.2,0.7,0.3,1.1,0.4l0.4,0.1v1.8h1.6V16l0.4-0.1c0.4-0.1,0.7-0.2,1.1-0.4l0.4-0.2l1.3,1.3l1.2-1.2l-1.3-1.3l0.2-0.4
		C25.7,13.4,25.8,13.1,25.9,12.7z M21.5,13.5c-1.1,0-2.1-0.9-2.1-2.1c0-1.1,0.9-2.1,2.1-2.1c1.1,0,2.1,0.9,2.1,2.1
		C23.6,12.6,22.6,13.5,21.5,13.5z"
                              />
                              <path
                                d="M24.3,17.7l-0.5-0.5v0.7c0,0.5-0.2,0.9-0.5,1.2c0.2,0.4,0.4,0.8,0.4,1.3c0,0.8-0.4,1.6-1,2.1H6.6
		c-0.8-0.6-1.3-1.6-1.3-2.6c0-1.8,1.5-3.3,3.3-3.3c0.2,0,0.3,0,0.5,0c0.5,0.1,0.9-0.2,1.1-0.6c0.7-1.4,2-2.5,3.5-2.9
		c-0.1-0.2-0.2-0.5-0.2-0.7v-1.4c-2,0.4-3.8,1.7-4.8,3.4c0,0,0,0,0,0c-3,0-5.4,2.4-5.4,5.4c0,1.8,0.9,3.5,2.4,4.5
		c0.2,0.1,0.4,0.2,0.6,0.2H23c0.2,0,0.4-0.1,0.6-0.2c1.4-0.9,2.2-2.4,2.2-4c0-0.8-0.2-1.6-0.6-2.3C24.9,18,24.6,17.9,24.3,17.7z"
                              />
                            </g>
                          </svg>
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="soracom_auth" />}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {findRouteAccess(ModuleType.Integrator) && (
                    <li
                      title={formatMessage("integrator_management")}
                      onClick={() => {
                        resetExtraModules();
                      }}
                    >
                      <NavLink to={RoutesConstants.IntegratorManagement}>
                        <span className="svgWidth">
                          <svg
                            clip-rule="evenodd"
                            fill-rule="evenodd"
                            fill="rgb(134, 137, 144)"
                            image-rendering="optimizeQuality"
                            shape-rendering="geometricPrecision"
                            text-rendering="geometricPrecision"
                            viewBox="0 0 512 512"
                            height="26"
                            width="26"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g id="Layer_x0020_1">
                              <path d="m256 319.64c-35.1 0-63.65-28.55-63.65-63.64s28.55-63.65 63.65-63.65c35.09 0 63.64 28.55 63.64 63.65 0 35.09-28.55 63.64-63.64 63.64zm95.7 192.36c-30.44 0-51.71-30.01-42.03-58.6h-47.67v-71.95c27.1 0 22.89 4.36 22.89-31.15 6-1.83 11.81-4.24 17.35-7.19l17.79 17.79c2.34 2.35 6.14 2.35 8.48 0l32.39-32.38c2.34-2.34 2.34-6.14 0-8.49l-17.79-17.78c2.94-5.55 5.35-11.35 7.19-17.35 35.51 0 31.15 4.2 31.15-22.9h71.95v151.83c0 21.82-17.75 39.57-39.57 39.57h-20.1c9.68 28.58-11.59 58.6-42.03 58.6zm-101.7-130.55v71.95h-57.1c-4.69 0-7.57-5.18-5.09-9.17 13.25-21.33-2.04-49.43-27.52-49.43-25.46 0-40.76 28.09-27.5 49.43 2.47 3.99-.41 9.17-5.1 9.17h-29.52c-21.82 0-39.57-17.75-39.57-39.57v-20.1c-28.59 9.67-58.6-11.59-58.6-42.03s30.01-51.7 58.6-42.03v-47.67h71.94c0 27.11-4.36 22.9 31.16 22.9 1.83 5.99 4.24 11.8 7.19 17.34l-17.79 17.8c-2.35 2.34-2.35 6.14 0 8.48l32.38 32.38c2.34 2.35 6.14 2.35 8.48 0l17.8-17.79c5.54 2.95 11.35 5.36 17.34 7.19 0 35.51-4.2 31.15 22.9 31.15zm-107.46-125.3v-17.05c42 0 20.61 3.59 38.97-27.3 1.4-2.36 1.02-5.37-.92-7.31l-16.76-16.77 23.89-23.89c29.68 29.67 11.93 17.13 46.86 8.23 2.66-.68 4.52-3.07 4.52-5.81v-23.71h33.79c0 42.01-3.57 20.6 27.31 38.97 2.36 1.4 5.37 1.02 7.31-.92l16.76-16.76 23.9 23.89c-29.68 29.69-17.12 11.94-8.23 46.86.67 2.66 3.07 4.52 5.81 4.52h23.7v33.8c-42 0-20.59-3.58-38.96 27.3-1.4 2.36-1.03 5.37.92 7.31l16.76 16.77-23.89 23.89c-29.7-29.69-11.93-17.11-46.86-8.23-2.66.68-4.52 3.07-4.52 5.81v23.7h-33.8c0-41.98 3.59-20.6-27.3-38.96-2.36-1.4-5.37-1.02-7.31.92l-16.77 16.76-23.9-23.89c29.69-29.69 17.13-11.93 8.24-46.86-.68-2.66-3.07-4.52-5.81-4.52h-23.71zm-12-6.15h-71.94v-151.83c0-21.82 17.75-39.57 39.57-39.57h20.1c-9.67-28.58 11.58-58.6 42.03-58.6s51.71 30.02 42.03 58.6h47.67v71.95c-27.11 0-22.9-4.36-22.9 31.15-6 1.84-11.8 4.24-17.35 7.19l-17.79-17.79c-2.34-2.34-6.14-2.34-8.48 0l-32.38 32.38c-2.35 2.35-2.35 6.15 0 8.49l17.79 17.79c-2.95 5.54-5.36 11.35-7.19 17.34-35.52 0-31.16-4.2-31.16 22.9zm131.46-119.45v-71.95h57.1c4.69 0 7.57 5.18 5.09 9.17-13.24 21.28 2.01 49.43 27.51 49.43 25.47 0 40.76-28.1 27.51-49.43-2.48-3.99.4-9.17 5.1-9.17h29.52c21.82 0 39.57 17.75 39.57 39.57v20.1c28.56-9.67 58.6 11.57 58.6 42.03 0 30.44-30.01 51.7-58.6 42.03v47.67h-71.95c0-27.1 4.36-22.9-31.15-22.9-1.84-5.99-4.25-11.8-7.19-17.34l17.79-17.79c2.34-2.35 2.34-6.14 0-8.49l-32.39-32.38c-2.34-2.34-6.14-2.34-8.48 0l-17.79 17.79c-5.54-2.95-11.35-5.35-17.35-7.19 0-35.51 4.21-31.15-22.89-31.15zm-6 73.8c-28.48 0-51.65 23.17-51.65 51.65s23.17 51.65 51.65 51.65 51.64-23.17 51.64-51.65-23.16-51.65-51.64-51.65z" />
                            </g>
                          </svg>
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="integrator_management" />}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {findRouteAccess(ModuleType.RouteGuidance) && (
                    <li
                      title={formatMessage("route_guidance")}
                      onClick={() => {
                        resetExtraModules();
                      }}
                    >
                      <NavLink to={RoutesConstants.RouteGuidance}>
                        <span className="svgWidth">
                          <svg
                            height="23"
                            viewBox="0 0 58 58"
                            width="23"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g id="Page-1">
                              <g
                                id="029---Lane-Split"
                                // fill="rgb(0,0,0)"
                                fill-rule="nonzero"
                                transform="translate(0 -1)"
                              >
                                <path
                                  id="Shape"
                                  d="m12.16 1.41-11.97 17.03c-.215543.301779-.2436504.6989388-.07275728 1.0280663.17089311.3291275.51191752.5346227.88275728.5319337h6v3c-.00165885 7.4488588 3.2135949 14.5355406 8.82 19.44l2.46 2.15c2.9997909 2.6278129 4.7201139 6.4219998 4.72 10.41v3c0 .5522847.4477153 1 1 1h10c.5522847 0 1-.4477153 1-1v-3c-.0185605-7.4444745-3.2302103-14.5232128-8.82-19.44l-2.46-2.15c-2.9997909-2.6278129-4.7201139-6.4219998-4.72-10.41v-3h6c.3708398.002689.7118642-.2028062.8827573-.5319337s.1427857-.7262873-.0727573-1.0280663l-12.03-17.03c-.1884814-.25913406-.4895695-.41244589-.81-.41244589s-.6215186.15331183-.81.41244589z"
                                />
                                <path
                                  id="Shape"
                                  d="m32 19.01c.0010575.2639741.1070737.5166863.2946687.7024054.187595.185719.4413599.2891901.7053313.2875946h6v3c.0001139 3.9880002-1.7202091 7.7821871-4.72 10.41l-2.46 2.15c-.51.45-1 .92-1.47 1.4.06.08.13.15.19.23 2.8642552 3.4272749 4.8575352 7.4961735 5.81 11.86.8042256-1.7028684 1.9515293-3.2212585 3.37-4.46l2.46-2.15c5.6064051-4.9044594 8.8216588-11.9911412 8.82-19.44v-3h6c.3708398.002689.7118642-.2028062.8827573-.5319337s.1427857-.7262873-.0727573-1.0280663l-12.03-17.03c-.1884814-.25913406-.4895695-.41244589-.81-.41244589s-.6215186.15331183-.81.41244589l-11.97 17.03c-.1217627.1652588-.1882548.3647353-.19.57z"
                                />
                              </g>
                            </g>
                          </svg>
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="route_guidance" />}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {findRouteAccess(ModuleType.Downloads) && (
                    <li
                      title={formatMessage("downloads")}
                      onClick={() => {
                        resetExtraModules();
                      }}
                    >
                      <NavLink to={RoutesConstants.Downloads}>
                        <span className="svgWidth">
                          <svg
                            id="svg5"
                            height="25"
                            viewBox="0 0 14.287499 14.287499"
                            width="25"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              id="path11788"
                              d="m5.8208329 1.5874998c-.1461193.0000146-.2645687.1184641-.2645833.2645834v3.7041663h-1.6536457c-.2356474.0000928-.3536381.284966-.1870683.4516519l3.2411455 3.2411455c.1033276.1032845.2708091.1032845.3741367 0l3.2411452-3.2411455c.16657-.1666858.04858-.4515588-.187068-.4516519h-1.6536457v-3.7041663c-.0000146-.1461193-.118464-.2645688-.2645833-.2645834zm-3.9687496 7.9374993c-.1461193.0000146-.2645688.118464-.2645834.2645833v2.6458326c.0000142.14612.1184638.264569.2645834.264584h10.5833317c.14612-.000014.26457-.118464.264584-.264584 0-.881944 0-1.763888 0-2.6458326-.000015-.1461195-.118464-.2645691-.264584-.2645833h-2.6458325c-.067154-.0000406-.131811.025453-.1808665.071313l-.9823687.9208739h-2.9657117l-.9818527-.9208735c-.0490555-.0458605-.1137127-.071354-.1808665-.0713134z"
                            />
                          </svg>
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="downloads" />}
                        </span>
                      </NavLink>
                    </li>
                  )}
                </React.Fragment>
              )}

              {getIsTenantAccessFromLocalStorage() == true &&
              (getUserType === userTypeEnum[4] ||
                getUserType === userTypeEnum[0] ||
                getUserType === userTypeEnum[1]) ? (
                <React.Fragment>
                  {getIsTenantAccessFromLocalStorage() == true && (
                    <li title={formatMessage("exit_tenant")} id="exit">
                      <a
                        className="btn btn-light-danger"
                        data-toggle="modal"
                        onClick={() => exitTenant()}
                      >
                        <span className="svgWidth">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="26"
                            height="26"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                            <polyline points="16 17 21 12 16 7"></polyline>
                            <line x1="21" y1="12" x2="9" y2="12"></line>
                          </svg>
                        </span>
                        <span className="nav-text">
                          <FormattedMessage id="exit_tenant" />{" "}
                        </span>
                      </a>
                    </li>
                  )}
                  {findRouteAccess(ModuleType.BranchManagement) && (
                    <li title={formatMessage("branch_title")}>
                      <NavLink
                        to={RoutesConstants.BranchManagement}
                        onClick={() => {
                          resetExtraModules();
                        }}
                      >
                        <span className="svgWidth svg-icon">
                          <svg
                            id="Layer_2"
                            fill="rgb(134, 137, 144)"
                            height="25"
                            width="25"
                            data-name="Layer 2"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 11.25 14.38"
                          >
                            <g id="_レイヤー_4" data-name="レイヤー 4">
                              <g>
                                <rect
                                  x="4.57"
                                  y="10.83"
                                  width="2.11"
                                  height="3.55"
                                />
                                <path d="M0,0V14.38H3.04v-4.31c0-.42,.34-.77,.77-.77h3.64c.42,0,.77,.34,.77,.77v4.31h3.04V0H0ZM4.79,6.62H2.03v-1.88h2.75v1.88Zm0-3.37H2.03V1.38h2.75v1.88Zm4.43,3.37h-2.75v-1.88h2.75v1.88Zm0-3.37h-2.75V1.38h2.75v1.88Z" />
                              </g>
                            </g>
                          </svg>
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="branch_title" />}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {findRouteAccess(ModuleType.MediaManagement) && (
                    <li
                      title={formatMessage("media_title")}
                      onClick={() => {
                        resetExtraModules();
                      }}
                    >
                      <NavLink to={RoutesConstants.FoldersManagement}>
                        <span className="svgWidth">
                          <svg
                            id="Layer_2"
                            data-name="Layer 2"
                            fill="rgb(134, 137, 144)"
                            height="26"
                            width="26"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 15.7 15.32"
                          >
                            <g id="_レイヤー_4" data-name="レイヤー 4">
                              <g>
                                <path d="M7.65,0C4.83,0,2.53,2.3,2.53,5.12s2.3,5.12,5.12,5.12,5.12-2.3,5.12-5.12S10.47,0,7.65,0Zm.4,6.3l-2.04,1.18V2.76l2.04,1.18,2.04,1.18-2.04,1.18Z" />
                                <path d="M15.68,8.35c-.08-.37-.38-.65-.76-.7l-2.64-.36c-.14,.3-.31,.58-.5,.84l3.01,.39-5.53,3.56L1.1,11.03l3.19-2.06c-.24-.21-.45-.43-.65-.68l-3.04,1.96c-.32,.21-.48,.58-.39,.96s.38,.65,.76,.7l8.17,1.1h0s.08,0,.12,0c.17,0,.35-.05,.49-.14l5.54-3.57c.32-.21,.48-.58,.39-.96Z" />
                                <path d="M15.5,10.65c-.08-.37-.38-.65-.76-.7l-1.08-.14-1.17,.75,2.11,.27-5.53,3.56L.92,13.33l2.43-1.57-1.41-.19-1.52,.98c-.32,.21-.48,.59-.39,.96s.38,.65,.76,.7l8.17,1.1h0s.08,0,.12,0c.17,0,.35-.05,.49-.14l5.54-3.57c.32-.21,.48-.59,.39-.96Z" />
                              </g>
                            </g>
                          </svg>
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="media_title" />}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {findRouteAccess(ModuleType.ParkingManagementList) && (
                    <li
                      title={formatMessage("parking_lot_title")}
                      onClick={() => {
                        resetExtraModules();
                      }}
                    >
                      <NavLink to={RoutesConstants.ParkingLotManagement}>
                        <span className="svgWidth svg-icon">
                          <svg
                            id="Layer_2"
                            data-name="Layer 2"
                            fill="rgb(134, 137, 144)"
                            height="23"
                            width="23"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 14.32 12.79"
                          >
                            <g id="_レイヤー_4" data-name="レイヤー 4">
                              <path d="M13.36,4.09h-.45l-1.15-3.47c-.11-.37-.44-.62-.83-.62H3.39c-.38,0-.72,.25-.83,.62l-1.15,3.47h-.45c-.53,0-.96,.43-.96,.97v7.74H2.21v-2.19H12.11v2.19h2.21V5.06c0-.53-.43-.97-.97-.97ZM3.85,8.39H1.6v-1.5H3.85v1.5Zm-.57-3.81l.97-2.75h5.77l.97,2.75H3.29Zm9.43,3.81h-2.25v-1.5h2.25v1.5Z" />
                            </g>
                          </svg>
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="parking_lot_title" />}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {findRouteAccess(ModuleType.SystemLog) && (
                    <li
                      title={formatMessage("system_logs_title")}
                      onClick={() => {
                        resetExtraModules();
                      }}
                    >
                      <NavLink to={RoutesConstants.SystemLogs}>
                        <span className="svgWidth">
                          <svg
                            id="Layer_2"
                            fill="rgb(134, 137, 144)"
                            height="26"
                            width="26"
                            data-name="Layer 2"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 16.47 12.13"
                          >
                            <g id="_レイヤー_4" data-name="レイヤー 4">
                              <g>
                                <path d="M12.79,12.13H2.38c-1.31,0-2.38-1.07-2.38-2.38V2.38C0,1.07,1.07,0,2.38,0H12.79c1.31,0,2.38,1.07,2.38,2.38v1.52h-1.13v-1.52c0-.69-.56-1.25-1.25-1.25H2.38c-.69,0-1.25,.56-1.25,1.25v7.36c0,.69,.56,1.25,1.25,1.25H12.79c.69,0,1.25-.56,1.25-1.25v-1.47h1.13v1.47c0,1.31-1.07,2.38-2.38,2.38Z" />
                                <polygon points="11.08 9.44 9.41 4.73 7.32 9.21 5.82 5.78 5.01 6.98 2.99 6.98 2.99 5.85 4.41 5.85 6.03 3.43 7.35 6.46 9.55 1.74 11.32 6.73 12.83 4.05 13.83 5.63 16.47 5.63 16.47 6.76 13.21 6.76 12.89 6.25 11.08 9.44" />
                              </g>
                            </g>
                          </svg>
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="system_logs_title" />}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {findRouteAccess(ModuleType.UserLog) && (
                    <li
                      title={formatMessage("user_logs_title")}
                      onClick={() => {
                        resetExtraModules();
                      }}
                    >
                      <NavLink to={RoutesConstants.UserLogs}>
                        <span className="svgWidth">
                          <svg
                            id="Layer_2"
                            data-name="Layer 2"
                            fill="rgb(134, 137, 144)"
                            height="26"
                            width="26"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 16.95 12.33"
                          >
                            <g id="_レイヤー_4" data-name="レイヤー 4">
                              <g>
                                <path d="M1.13,8.32V2.1c0-.53,.43-.97,.97-.97H12.15c.53,0,.97,.43,.97,.97v1.59h1.13v-1.59c0-1.16-.94-2.1-2.1-2.1H2.1C.94,0,0,.94,0,2.1v6.22c0,1.16,.94,2.1,2.1,2.1h6.35v-1.13H2.1c-.53,0-.97-.43-.97-.97Z" />
                                <polygon points="16.95 11.25 13.24 7.56 15.74 6.54 8.23 3.69 11.24 11.14 12.19 8.64 15.89 12.33 16.95 11.25" />
                                <rect
                                  x="2.31"
                                  y="3.4"
                                  width="4.81"
                                  height="1.1"
                                />
                                <rect
                                  x="2.31"
                                  y="5.84"
                                  width="3.43"
                                  height="1.1"
                                />
                              </g>
                            </g>
                          </svg>
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="user_logs_title" />}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {findRouteAccess(ModuleType.SoracomAuth) && (
                    <li
                      title={formatMessage("soracom_auth")}
                      onClick={() => {
                        resetExtraModules();
                      }}
                    >
                      <NavLink to={RoutesConstants.SoracomAuth}>
                        <span className="svgWidth soraComIcon">
                          <svg
                            version="1.1"
                            id="デザイン"
                            xmlns="http://www.w3.org/2000/svg"
                            x="0px"
                            y="0px"
                            viewBox="0 0 30 30"
                            fill="rgb(134, 137, 144)"
                            height="30"
                            width="30"
                          >
                            <g>
                              <path d="M10.5,7.6H4.1C3.8,7.6,3.5,7.3,3.5,7s0.2-0.5,0.5-0.5h6.4C10.8,6.5,11,6.8,11,7S10.8,7.6,10.5,7.6z" />
                              <path d="M9.1,10h-5c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h5c0.3,0,0.5,0.2,0.5,0.5C9.6,9.7,9.4,10,9.1,10z" />
                              <path
                                d="M7.8,12.4H4.1c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h3.7c0.3,0,0.5,0.2,0.5,0.5
		C8.3,12.2,8.1,12.4,7.8,12.4z"
                              />
                              <path
                                d="M25.9,12.7l0.1-0.4h1.8v-1.6H26l-0.1-0.4c-0.1-0.4-0.2-0.7-0.4-1.1l-0.2-0.4l1.3-1.3l-1.2-1.2l-1.3,1.3
		l-0.4-0.2c-0.3-0.2-0.7-0.3-1.1-0.4l-0.4-0.1V5.1h-1.6v1.8L20.3,7c-0.4,0.1-0.7,0.2-1.1,0.4l-0.4,0.2l-1.3-1.3l-1.2,1.2l1.3,1.3
		l-0.2,0.4c-0.2,0.3-0.3,0.7-0.4,1.1L17,10.7h-1.8v1.6H17l0.1,0.4c0.1,0.4,0.2,0.7,0.4,1.1l0.2,0.4l-1.3,1.3l1.2,1.2l1.3-1.3
		l0.4,0.2c0.3,0.2,0.7,0.3,1.1,0.4l0.4,0.1v1.8h1.6V16l0.4-0.1c0.4-0.1,0.7-0.2,1.1-0.4l0.4-0.2l1.3,1.3l1.2-1.2l-1.3-1.3l0.2-0.4
		C25.7,13.4,25.8,13.1,25.9,12.7z M21.5,13.5c-1.1,0-2.1-0.9-2.1-2.1c0-1.1,0.9-2.1,2.1-2.1c1.1,0,2.1,0.9,2.1,2.1
		C23.6,12.6,22.6,13.5,21.5,13.5z"
                              />
                              <path
                                d="M24.3,17.7l-0.5-0.5v0.7c0,0.5-0.2,0.9-0.5,1.2c0.2,0.4,0.4,0.8,0.4,1.3c0,0.8-0.4,1.6-1,2.1H6.6
		c-0.8-0.6-1.3-1.6-1.3-2.6c0-1.8,1.5-3.3,3.3-3.3c0.2,0,0.3,0,0.5,0c0.5,0.1,0.9-0.2,1.1-0.6c0.7-1.4,2-2.5,3.5-2.9
		c-0.1-0.2-0.2-0.5-0.2-0.7v-1.4c-2,0.4-3.8,1.7-4.8,3.4c0,0,0,0,0,0c-3,0-5.4,2.4-5.4,5.4c0,1.8,0.9,3.5,2.4,4.5
		c0.2,0.1,0.4,0.2,0.6,0.2H23c0.2,0,0.4-0.1,0.6-0.2c1.4-0.9,2.2-2.4,2.2-4c0-0.8-0.2-1.6-0.6-2.3C24.9,18,24.6,17.9,24.3,17.7z"
                              />
                            </g>
                          </svg>
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="soracom_auth" />}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {findRouteAccess(ModuleType.Integrator) && (
                    <li
                      title={formatMessage("integrator_management")}
                      onClick={() => {
                        resetExtraModules();
                      }}
                    >
                      <NavLink to={RoutesConstants.IntegratorManagement}>
                        <span className="svgWidth">
                          <svg
                            height="26"
                            width="26"
                            fill="rgb(134, 137, 144)"
                            id="Layer_2"
                            data-name="Layer 2"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 26.62 23.19"
                          >
                            <g id="_レイヤー_4" data-name="レイヤー 4">
                              <g>
                                <g>
                                  <polygon points="8.72 14.01 11.47 9.24 9.62 9.24 6.87 14.01 8.72 14.01" />
                                  <rect
                                    x="10.46"
                                    y="19.08"
                                    width="5.69"
                                    height="1.61"
                                  />
                                  <polygon points="15.15 9.24 17.9 14.01 19.75 14.01 17 9.24 15.15 9.24" />
                                </g>
                                <path d="M17.28,2.62h-.29l-.74-2.22c-.07-.24-.28-.4-.53-.4h-4.84c-.25,0-.46,.16-.53,.4l-.74,2.22h-.29c-.34,0-.62,.28-.62,.62v4.96h1.42v-1.4h6.34v1.4h1.42V3.24c0-.34-.28-.62-.62-.62Zm-6.09,2.75h-1.44v-.96h1.44v.96Zm-.36-2.44l.62-1.76h3.7l.62,1.76h-4.94Zm6.04,2.44h-1.44v-.96h1.44v.96Z" />
                                <path d="M8.56,17.61h-.29l-.74-2.22c-.07-.24-.28-.4-.53-.4H2.17c-.25,0-.46,.16-.53,.4l-.74,2.22h-.29c-.34,0-.62,.28-.62,.62v4.96H1.42v-1.4H7.76v1.4h1.42v-4.96c0-.34-.28-.62-.62-.62Zm-6.09,2.75H1.03v-.96h1.44v.96Zm-.36-2.44l.62-1.76h3.7l.62,1.76H2.11Zm6.04,2.44h-1.44v-.96h1.44v.96Z" />
                                <path d="M26,17.61h-.29l-.74-2.22c-.07-.24-.28-.4-.53-.4h-4.84c-.25,0-.46,.16-.53,.4l-.74,2.22h-.29c-.34,0-.62,.28-.62,.62v4.96h1.42v-1.4h6.34v1.4h1.42v-4.96c0-.34-.28-.62-.62-.62Zm-6.09,2.75h-1.44v-.96h1.44v.96Zm-.36-2.44l.62-1.76h3.7l.62,1.76h-4.94Zm6.04,2.44h-1.44v-.96h1.44v.96Z" />
                              </g>
                            </g>
                          </svg>
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="integrator_management" />}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {findRouteAccess(ModuleType.RouteGuidance) && (
                    <li
                      title={formatMessage("route_guidance")}
                      onClick={() => {
                        resetExtraModules();
                      }}
                    >
                      <NavLink to={RoutesConstants.RouteGuidance}>
                        <span className="svgWidth">
                          <svg
                            height="23"
                            viewBox="0 0 58 58"
                            width="23"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g id="Page-1">
                              <g
                                id="029---Lane-Split"
                                // fill="rgb(0,0,0)"
                                fill-rule="nonzero"
                                transform="translate(0 -1)"
                              >
                                <path
                                  id="Shape"
                                  d="m12.16 1.41-11.97 17.03c-.215543.301779-.2436504.6989388-.07275728 1.0280663.17089311.3291275.51191752.5346227.88275728.5319337h6v3c-.00165885 7.4488588 3.2135949 14.5355406 8.82 19.44l2.46 2.15c2.9997909 2.6278129 4.7201139 6.4219998 4.72 10.41v3c0 .5522847.4477153 1 1 1h10c.5522847 0 1-.4477153 1-1v-3c-.0185605-7.4444745-3.2302103-14.5232128-8.82-19.44l-2.46-2.15c-2.9997909-2.6278129-4.7201139-6.4219998-4.72-10.41v-3h6c.3708398.002689.7118642-.2028062.8827573-.5319337s.1427857-.7262873-.0727573-1.0280663l-12.03-17.03c-.1884814-.25913406-.4895695-.41244589-.81-.41244589s-.6215186.15331183-.81.41244589z"
                                />
                                <path
                                  id="Shape"
                                  d="m32 19.01c.0010575.2639741.1070737.5166863.2946687.7024054.187595.185719.4413599.2891901.7053313.2875946h6v3c.0001139 3.9880002-1.7202091 7.7821871-4.72 10.41l-2.46 2.15c-.51.45-1 .92-1.47 1.4.06.08.13.15.19.23 2.8642552 3.4272749 4.8575352 7.4961735 5.81 11.86.8042256-1.7028684 1.9515293-3.2212585 3.37-4.46l2.46-2.15c5.6064051-4.9044594 8.8216588-11.9911412 8.82-19.44v-3h6c.3708398.002689.7118642-.2028062.8827573-.5319337s.1427857-.7262873-.0727573-1.0280663l-12.03-17.03c-.1884814-.25913406-.4895695-.41244589-.81-.41244589s-.6215186.15331183-.81.41244589l-11.97 17.03c-.1217627.1652588-.1882548.3647353-.19.57z"
                                />
                              </g>
                            </g>
                          </svg>
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="route_guidance" />}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {findRouteAccess(ModuleType.Downloads) && (
                    <li
                      title={formatMessage("downloads")}
                      onClick={() => {
                        resetExtraModules();
                      }}
                    >
                      <NavLink to={RoutesConstants.Downloads}>
                        <span className="svgWidth">
                          <svg
                            id="svg5"
                            height="25"
                            viewBox="0 0 14.287499 14.287499"
                            width="25"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              id="path11788"
                              d="m5.8208329 1.5874998c-.1461193.0000146-.2645687.1184641-.2645833.2645834v3.7041663h-1.6536457c-.2356474.0000928-.3536381.284966-.1870683.4516519l3.2411455 3.2411455c.1033276.1032845.2708091.1032845.3741367 0l3.2411452-3.2411455c.16657-.1666858.04858-.4515588-.187068-.4516519h-1.6536457v-3.7041663c-.0000146-.1461193-.118464-.2645688-.2645833-.2645834zm-3.9687496 7.9374993c-.1461193.0000146-.2645688.118464-.2645834.2645833v2.6458326c.0000142.14612.1184638.264569.2645834.264584h10.5833317c.14612-.000014.26457-.118464.264584-.264584 0-.881944 0-1.763888 0-2.6458326-.000015-.1461195-.118464-.2645691-.264584-.2645833h-2.6458325c-.067154-.0000406-.131811.025453-.1808665.071313l-.9823687.9208739h-2.9657117l-.9818527-.9208735c-.0490555-.0458605-.1137127-.071354-.1808665-.0713134z"
                            />
                          </svg>
                        </span>
                        <span className="nav-text">
                          {<FormattedMessage id="downloads" />}
                        </span>
                      </NavLink>
                    </li>
                  )}
                </React.Fragment>
              ) : (
                ""
              )}
            </ul>
          </nav>
        </div>
        <div className="aside-footer">
          <ul>
            <li
              data-testid="UserProfile"
              title={formatMessage("user_profile")}
              onClick={() => {
                props.UserProfileToggleHandler();
              }}
            >
              <span className="profile_svg svg-icon">
                <svg
                  id="Layer_2"
                  width="28"
                  height="28"
                  fill="rgb(134, 137, 144)"
                  data-name="Layer 2"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 11.03 17.46"
                >
                  <g id="_レイヤー_4" data-name="レイヤー 4">
                    <g>
                      <circle cx="5.51" cy="2.77" r="2.77" />
                      <polygon points="3.97 6.89 0 6.89 3.09 17.46 4.21 17.46 6.81 9.35 8.16 9.35 5.65 17.46 7.38 17.46 11.03 6.89 3.97 6.89" />
                    </g>
                  </g>
                </svg>
              </span>
              <span className="nav-text ms-1 profile-svg">
                <FormattedMessage id="user_profile" />
              </span>
            </li>
            <li
              data-testid="Logout"
              title={formatMessage("logout")}
              className="logout"
              onClick={props.logoutPopupToggleHandler}
            >
              <span className="profile_svg">
                <svg
                  width="23"
                  height="23"
                  id="Layer_2"
                  fill="rgb(134, 137, 144)"
                  data-name="Layer 2"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 13.86 13.87"
                >
                  <g id="_レイヤー_4" data-name="レイヤー 4">
                    <g>
                      <path d="M8.91,13.87H2.17c-1.19,0-2.17-.97-2.17-2.17V2.17C0,.97,.97,0,2.17,0h6.74c1.19,0,2.17,.97,2.17,2.17v1.89h-1v-1.89c0-.64-.52-1.16-1.16-1.16H2.17c-.64,0-1.16,.52-1.16,1.16V11.7c0,.64,.52,1.16,1.16,1.16h6.74c.64,0,1.16-.52,1.16-1.16v-2.11h1v2.11c0,1.19-.97,2.17-2.17,2.17Z" />
                      <polygon points="2.65 7.02 6.27 7.02 6.27 3.86 13.86 8.27 2.65 8.27 2.65 7.02" />
                    </g>
                  </g>
                </svg>
              </span>
              <span className="nav-text ms-1">
                <FormattedMessage id="logout" />
              </span>
            </li>
          </ul>
        </div>
      </aside>
    </React.Fragment>
  );
};

export default UserProfilePopupHOC(
  LogoutPopupHOC(injectIntl(observer(LeftNavBar)))
);
